import { Skeleton, Box, Stack } from "@mui/material";

interface TableSkeletonProps {
    rows?: number;
    columns?: number;
    showHeader?: boolean;
    height?: number;
}

export default function TableSkeleton({ 
    rows = 5, 
    columns = 3, 
    showHeader = true, 
    height = 30 
}: TableSkeletonProps) {
    return (
        <Box>
            {showHeader && (
                <Stack direction="row" spacing={1} mb={1}>
                    {Array.from({ length: columns }).map((_, index) => (
                        <Skeleton 
                            key={`header-${index}`}
                            variant="rectangular" 
                            width="100%" 
                            height={32}
                            sx={{ flex: 1 }}
                        />
                    ))}
                </Stack>
            )}

            <Stack spacing={0.5}>
                {Array.from({ length: rows }).map((_, rowIndex) => (
                    <Skeleton 
                        key={`row-${rowIndex}`}
                        variant="rectangular" 
                        width="100%" 
                        height={height}
                    />
                ))}
            </Stack>
        </Box>
    );
}